import axios from 'axios';

const API = axios.create({
  baseURL: 'https://netstock-production.up.railway.app/api',
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('netstock_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('netstock_token');
      localStorage.removeItem('netstock_user');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (data) => API.post('/auth/login', data),
  register: (data) => API.post('/auth/register', data),
  me: () => API.get('/auth/me'),
  getUsers: () => API.get('/auth/users'),
  updateUser: (id, data) => API.put(`/auth/users/${id}`, data),
  deleteUser: (id) => API.delete(`/auth/users/${id}`),
};

export const equipementsAPI = {
  getAll: (params) => API.get('/equipements', { params }),
  getOne: (id) => API.get(`/equipements/${id}`),
  create: (data) => API.post('/equipements', data),
  update: (id, data) => API.put(`/equipements/${id}`, data),
  delete: (id) => API.delete(`/equipements/${id}`),
  mouvement: (id, data) => API.post(`/equipements/${id}/mouvement`, data),
};

export const categoriesAPI = {
  getAll: () => API.get('/categories'),
  create: (data) => API.post('/categories', data),
  update: (id, data) => API.put(`/categories/${id}`, data),
  delete: (id) => API.delete(`/categories/${id}`),
};

export const mouvementsAPI = {
  getAll: (params) => API.get('/mouvements', { params }),
};

export const statsAPI = {
  get: () => API.get('/stats'),
};

export const organisationsAPI = {
  getAll: () => API.get('/organisations'),
  create: (data) => API.post('/organisations', data),
  update: (id, data) => API.put(`/organisations/${id}`, data),
  delete: (id) => API.delete(`/organisations/${id}`),
};

export default API;
